import { v4 as uuidv4 } from "uuid";
import environment from "environment";
import jsonFetch from "./jsonFetch";

const fileService = (token: string, directory: string = "temp") => {
  return {
    upload: async (file: any, load: any, progress: any) => {
      const key = uuidv4();
      const fileExtension = file.name.split(".").pop();
      const fileName = `${key}.${fileExtension}`.toLowerCase();
      const { url } = await jsonFetch<{ url: string }>({
        token,
        endpoint: `${environment.presignerUrl}/sign?key=${directory}/${fileName}&verb=put`,
      });
      fetchWithProgress(file, fileName, "put", url, load, progress);
      return fileName;
    },
    delete: async (fileName: string) => {
      const { url } = await jsonFetch<{ url: string }>({
        token,
        endpoint: `${environment.presignerUrl}/sign?key=${directory}/${fileName}&verb=delete`,
      });
      await jsonFetch<void>({
        endpoint: url,
        method: "DELETE",
      });
    },
    download: async (fileName: string) => {
      const { url } = await jsonFetch<{ url: string }>({
        token,
        endpoint: `${environment.presignerUrl}/sign?key=${directory}/${fileName}&verb=get`,
      });
      const response = await jsonFetch<{ url: string }>({
        endpoint: url,
      });
      return response;
    },
    getBlob: async (url: string) => {
      return fetch(url, {
        method: "GET",
        headers: {
          Authorization: token ? `Bearer ${token}` : "",
        },
      })
        .then((response) => response.blob())
        .then((images) => URL.createObjectURL(images))
        .catch((error) => {
          console.error(error);
          throw error;
        });
    },
  };
};

const fetchWithProgress = (
  file: any,
  fileName: string,
  verb: string,
  url: string,
  load: any,
  progress: any
) => {
  var xhr = new XMLHttpRequest();
  xhr.upload.onprogress = (e) => {
    progress(e.lengthComputable, e.loaded, e.total);
  };
  xhr.open(verb, url);
  xhr.setRequestHeader("Content-Type", "application/octet-stream");
  xhr.onload = () => {
    if (xhr.status === 200) {
      load(fileName);
    } else {
      throw Error("error at UploadFile - fetchWithProgress");
    }
  };
  xhr.onerror = (e) => {
    console.error(e);
    throw Error("error at UploadFile - fetchWithProgress");
  };
  xhr.send(file);
};

export default fileService;
